import React, { FC } from 'react';
import { NakedButton, Flex } from 'roo-ui/components';
import styled from '@emotion/styled';
import { fontSize, FontSizeProps, ResponsiveValue } from 'styled-system';
import { DateRangeRenderProps } from '../../types';

export const DesktopActions: FC<DateRangeRenderProps> = ({ getDoneProps, getCancelProps }) => (
  <Flex px="14" py="6" justifyContent="space-between" borderTop="1" borderColor="greys.alto">
    <TextButton data-testid="date-range-picker-cancel" fontSize="lg" color="greys.steel" hoverColor="maroon" {...getCancelProps()}>
      Cancel
    </TextButton>

    <TextButton data-testid="date-range-picker-apply" fontSize="lg" color="brand.primary" hoverColor="maroon" {...getDoneProps()}>
      Done
    </TextButton>
  </Flex>
);

type AdditionalTextButtonProps = { hoverColor?: ResponsiveValue<string> } & FontSizeProps;

const TextButton = styled(NakedButton)<AdditionalTextButtonProps>`
  ${fontSize}
`;
